import { useEffect } from 'react';
import {
  isApp,
  isMobile,
  loadByAppsFlyerScript,
  getDeepLinkUrl,
  APPS_FLYERS,
} from '@web3/base-utils';

interface Props {
  remConfig?: {
    breakpointWidth: number;
    designWidth: number;
  };
}

export const AppsFlyers = (props: Props) => {
  const { remConfig } = props;
  useEffect(() => {
    if (isMobile && !isApp()) {
      loadByAppsFlyerScript().then(() => {
        const deepLinkUrl = getDeepLinkUrl();
        /* eslint-disable jsx-control-statements/jsx-jcs-no-undef */
        window[APPS_FLYERS]?.showSmartBanner?.(deepLinkUrl, true);
      });
    }
  }, []);

  return null;
};
